import { updateDoc, doc } from "firebase/firestore";
import { useState } from "react";
import { toast } from "react-toastify";
import TopTitleFormComponent from "./TopTitleFormComponent";
import DropDownComponent from "../DropDownComponent";
import { db } from "../../firebase";
import { Button, CircularProgress, Stack } from "@mui/material";

export default function EditRoleMobile(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(props.roleUser);

  const handleRoleChange = (v) => {
    setSelectedRole(v?.target?.value ?? v);
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      await updateDoc(doc(db, "roles", props.userId), { role: selectedRole });
      toast.success("Role updated successfully!");
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while updating the role.");
    }
    setIsLoading(false);
    props.closemodal();
  };

  return (
    // <>
    //   <div
    //     className="inputAndLabelModalContainerTitle2"
    //     style={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 1 }}
    //   >
    //     <TopTitleFormComponent
    //       title={`Edit ${props.userName} role`}
    //       closemodal={props.closemodal}
    //     />
    //   </div>

    //   <div style={{ marginTop: "60px", height: "250px" }}>
    //     <div className="tab-form-container-centered">
    <>
      <div style={{ marginTop: 4, minHeight: 140 }}>
        <div
          className="tab-form-container-centered"
          style={{ padding: "8px 0" }}
        >
          <DropDownComponent
            api="roles"
            title="User role"
            value={selectedRole}
            onChange={handleRoleChange}
          />
        </div>

        {/* <div className="line4-modal-centered">
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={24} color="secondary" />
              ) : (
                "Save"
              )}
            </Button>
          </>
        </div> */}
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button
            variant="outlined"
            onClick={props.closemodal}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={18} /> : "Save"}
          </Button>
        </Stack>
      </div>
    </>
  );
}
